import React from 'react';

import SectionCard from '~components/SectionCard';
import ProgressBar from '~components/visualisation/progress-bar/ProgressBar';

interface ComponentProps {
  title?: string;
  description?: string;
  data?: { used: number; available: number; target?: number };
}

const CaseManagementOverview: React.FC<ComponentProps> = ({
  title = 'Case Management Overview',
  description = 'Expenditure rate for case management',
  data,
}) => {
  return (
    <SectionCard title={title} description={description} className="budget-overview">
      <div className="overview-layout">
        <ProgressBar
          data={{
            used: data?.used || 0,
            total: data?.available || 0,
            target: data?.target,
            units: 'currency',
          }}
          showLabel={true}
          showTooltip={true}
          width="90%"
        />
      </div>
    </SectionCard>
  );
};

export default CaseManagementOverview;
